export class PagePayErrorPresenter {
  form_error = {
    title: 'Pago Reachazado',
    subtitle: 'Superó el tiempo maxino para realizar el pago',
    detail1: 'Pago rechzado No.',
    detail2: 'E-1233-5667',
    footer: 'Esta pantalla se cerrara en 10 Segundos.',
  };
}
